
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqComponent } from './faq.component';
import { MaterialModule } from '../../common/material-module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  declarations: [FaqComponent]
})
export class FaqModule { }
